/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

import * as React from "react";
import { createUseScreenVariants } from "@plasmicapp/react-web";

export type ThemeOrangeValue = "override";
export const ThemeOrangeContext = React.createContext<
  ThemeOrangeValue | undefined
>("PLEASE_RENDER_INSIDE_PROVIDER" as any);
export function ThemeOrangeContextProvider(
  props: React.PropsWithChildren<{ value: ThemeOrangeValue | undefined }>
) {
  return (
    <ThemeOrangeContext.Provider value={props.value}>
      {props.children}
    </ThemeOrangeContext.Provider>
  );
}

export function useThemeOrange() {
  return React.useContext(ThemeOrangeContext);
}

export default ThemeOrangeContext;
/* prettier-ignore-end */
